// ProgressBar.js
import React from 'react';

const ProgressBarRiskLevel = ({ percentage, maxValue = 5.5 }) => {

  const value = (percentage / maxValue) * 100;
  return (
    <div className="" style={{marginBottom:"10px"}}>
     <div className="progress-bar-container-ai mt-1">
          <div
            className={`filler ${percentage >= 50 ? 'red' : ''}`}
            style={{ width: `${value}%` }}
          >
            {/* Add the cross line */}
            <div className="cross-line"></div>
          </div>
        </div>
      <div className="progress-container-portfolio">
        <span className="small-gray">Safe</span>
        
        <span className="small-gray right">Dangerous</span>
      </div>
    </div>
  );
};

export default ProgressBarRiskLevel;
